const TIPTAP_EDITOR_SCHEMA_VERSION = "1.0.0";

export { TIPTAP_EDITOR_SCHEMA_VERSION };
//# sourceMappingURL=types.js.map
